module.exports = __webpack_public_path__ + "img/926B48_4C2D0D_5F3913_AA8874-256px.440816bc.png";